module.exports = __webpack_public_path__ + "static/media/book details.471a3881.svg";